/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ allowed: NonNullable<unknown> }} Error_Product_Image_File_TypeInputs */

const vi_error_product_image_file_type = /** @type {(inputs: Error_Product_Image_File_TypeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`File ảnh không đúng loại (chỉ nhận ${i?.allowed}). Chọn file khác.`)
};

/**

* @param {Error_Product_Image_File_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_product_image_file_type = /** @type {((inputs: Error_Product_Image_File_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Product_Image_File_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_product_image_file_type(inputs)
});